import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { statusHelper } from 'src/app/helpers';
import { MenuEnum } from 'src/enums/menu.enum';
import { reduxRootTypes } from 'src/types';
import { AuthorizationPropsType } from '../authorized-route.config';
import useLogout from 'src/app/hooks/useLogout';
import { useTranslation } from 'react-i18next';

const AuthorizedPlayerRoute: React.FC<AuthorizationPropsType> = ({
  authenticated,
  component,
  exact,
  path,
  redirectTo,
  userRoleId,
  pathpermission,
  // menu,
}) => {
  const { t } = useTranslation();

  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const userRolePermissionState = useSelector((state: reduxRootTypes.RootStateType) => state.userRolePermissionState);
  const logout = useLogout();

  const checker = (arr: number[] | undefined, target: number[] | undefined) =>
    target?.map((v: any) => arr?.includes(v));

  const permissionConvertAndReturnChecker = (
    userPermissionsArray: number[] | undefined,
    requiredPermissionNumbersArray: number[] | undefined,
  ) => {
    return checker(userPermissionsArray, requiredPermissionNumbersArray);
  };

  const getCheckUserRolePermission = (x: any, y?: any) => {
    return x.userrolepermissions.filter((temp: any) => temp.userRoleId === y[0].id).map((e: any) => e.permissionId);
  };

  useEffect(() => {
    if (userRolePermissionState.userrolepermissions.length > 0) {
      if (!authenticated || !userRoleId) {
        statusHelper.displayErrorMessage(t('errors.sessionExpired'));
        return;
      }
      let tempCheckUserRolePermission: number[] = [];
      if (userRolePermissionState.userrolepermissions.length > 0 && userRoleId) {
        tempCheckUserRolePermission = getCheckUserRolePermission(userRolePermissionState, userRoleId);
      }
      if (!permissionConvertAndReturnChecker(tempCheckUserRolePermission, pathpermission)) {
        statusHelper.displayErrorMessage(t('errors.authorizationError'));
      }
    }
  }, [authenticated, userRoleId, userRolePermissionState]);

  if (authenticated && userRoleId && userRolePermissionState.userrolepermissions.length > 0) {
    let tempCheckUserRolePermission: number[] = [];
    if (userRolePermissionState.userrolepermissions.length > 0 && userRoleId) {
      tempCheckUserRolePermission = getCheckUserRolePermission(userRolePermissionState, userRoleId);
    }
    if (pathpermission && pathpermission?.length > 0) {
      return <Route exact={exact} path={path} component={component} />;
    }
    if (permissionConvertAndReturnChecker(tempCheckUserRolePermission, pathpermission)) {
      return <Route exact={exact} path={path} component={component} />;
    }

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    } else {
      logout();
      return null;
    }
    // return <Redirect to={redirectTo || '/Login'} />;
  }

  return <Route exact={exact} path={path} component={component} />;
};

export default AuthorizedPlayerRoute;
